const INT_MIN = -2147483648
const INT_MAX = 2147483647

export function buildParameterLayout(parameters = []) {
  const candidates = new Map()
  parameters.forEach((parameter, index) => {
    const metadata = parameter?.range
    if (!metadata?.group || !['start', 'end'].includes(metadata.boundary)) return
    const candidate = candidates.get(metadata.group) ?? {
      group: metadata.group, domain: metadata.domain, firstIndex: index, start: null, end: null, valid: true,
    }
    if (candidate.domain !== metadata.domain || candidate[metadata.boundary]) candidate.valid = false
    candidate[metadata.boundary] = parameter
    candidate.firstIndex = Math.min(candidate.firstIndex, index)
    candidates.set(metadata.group, candidate)
  })

  const validGroups = new Map([...candidates].filter(([, candidate]) => (
    candidate.valid && candidate.start && candidate.end
  )))
  const emitted = new Set()
  const layout = []
  parameters.forEach((parameter) => {
    const group = parameter?.range?.group
    const candidate = group ? validGroups.get(group) : null
    if (!candidate) {
      layout.push({ kind: 'parameter', parameter })
      return
    }
    if (emitted.has(group)) return
    emitted.add(group)
    layout.push({ kind: 'range', ...candidate })
  })
  return layout
}

export function validateProductRanges(parameters = [], values = {}) {
  const errors = {}
  let firstInvalidName = ''
  for (const item of buildParameterLayout(parameters)) {
    if (item.kind !== 'range') continue
    const start = parseBoundary(values[item.start.name])
    const end = parseBoundary(values[item.end.name])
    let error = null
    if (start.state === 'required' || end.state === 'required') {
      error = { code: 'required', firstInvalidName: start.state === 'required' ? item.start.name : item.end.name }
    } else if (start.state === 'integer' || end.state === 'integer') {
      error = { code: 'integer', firstInvalidName: start.state === 'integer' ? item.start.name : item.end.name }
    } else if (start.value > end.value) {
      error = { code: 'order', firstInvalidName: item.start.name }
    }
    if (error) {
      errors[item.group] = error
      if (!firstInvalidName) firstInvalidName = error.firstInvalidName
    }
  }
  return { valid: !Object.keys(errors).length, errors, firstInvalidName }
}

export function buildParameterValues(parameters = [], parameterValues = {}) {
  const values = {}
  for (const parameter of parameters) {
    if (parameter.autoFilled) continue
    const value = parameterValues[parameter.name]
    if (parameter.selection === 'Multiple') {
      if (Array.isArray(value) && value.length) values[parameter.name] = [...value]
    } else if (value !== '') {
      values[parameter.name] = value
    }
  }
  return values
}

function parseBoundary(raw) {
  if (raw == null || String(raw).trim() === '') return { state: 'required' }
  const normalized = String(raw).trim()
  if (!/^-?\d+$/.test(normalized)) return { state: 'integer' }
  const value = Number(normalized)
  if (!Number.isSafeInteger(value) || value < INT_MIN || value > INT_MAX) return { state: 'integer' }
  return { state: 'valid', value }
}
